export default __webpack_public_path__ + "static/media/May the fourth.5be67101.png";